require('./bootstrap');
// require('./.env');

import {createApp, h} from 'vue';
import { App, plugin } from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3'
// import { Inertia } from '@inertiajs/inertia'
import ZComm from './Modules/z-comm'
import ZUtil from './Modules/z-util'
import { InertiaProgress } from '@inertiajs/progress'
import WaveUI from 'wave-ui'

import 'wave-ui/dist/wave-ui.css'
// import 'font-awesome/css/font-awesome.min.css'

import VueFusionCharts from 'vue-fusioncharts';
import FusionCharts from 'fusioncharts';
import Column2D from 'fusioncharts/fusioncharts.charts';
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import CKEditor from '@ckeditor/ckeditor5-vue';

const el = document.getElementById('app');

InertiaProgress.init();

const app = createApp({
    render: () => h(App, {
        initialPage: JSON.parse(el.dataset.page),
        resolveComponent: name => require(`./Pages/${name}`).default
    }),
    created() {
        this.$zcomm.app = this
        this.$zutil.app = this
    }
});

// Register a-la-carte components from the given list.
// this to move to the npm later, it's here now easier dev purposesss
import * as components from './Components'

for (let id in components) {
  const component = components[id]
  // console.log(component.name);
  app.component(component.name, component)
}

new WaveUI(app, {
  // Some Wave UI options.
})

app.config.globalProperties.$route = window.route;
app.provide('$route', window.route);

app.config.globalProperties.$zcomm = new ZComm
app.config.globalProperties.$zutil = new ZUtil

app.config.globalProperties.kong = process.env.MIX_SERVICE_KONG;

app.config.globalProperties.service_kutipan = process.env.MIX_SERVICE_KUTIPAN;
app.config.globalProperties.service_utiliti = process.env.MIX_SERVICE_UTILITI;
app.config.globalProperties.service_pembayaran = process.env.MIX_SERVICE_PEMBAYARAN;
app.config.globalProperties.service_bil_pelbagai = process.env.MIX_SERVICE_BIL_PELBAGAI;
app.config.globalProperties.service_deposit = process.env.MIX_SERVICE_DEPOSIT;
app.config.globalProperties.service_tunggakan = process.env.MIX_SERVICE_TUNGGAKAN;
app.config.globalProperties.service_cukai = process.env.MIX_SERVICE_CUKAI;
app.config.globalProperties.service_penyata = process.env.MIX_SERVICE_PENYATA;
app.config.globalProperties.service_ibayaq = process.env.MIX_SERVICE_IBAYAQ;
app.config.globalProperties.service_pendidikan = process.env.MIX_SERVICE_PENDIDIKAN;
app.config.globalProperties.service_perumahan = process.env.MIX_SERVICE_PERUMAHAN;
app.config.globalProperties.service_bantuan = process.env.MIX_SERVICE_BANTUAN;
app.config.globalProperties.service_laporan = process.env.MIX_SERVICE_LAPORAN;



import ZenOne from './Shared/ZenTwo'
app.use(CKEditor);
app.use(plugin)
.component('InertiaLink', Link)
.component('ZenOne', ZenOne)
.component('Layout', ZenOne)
.mount(el);

app.use(VueFusionCharts, FusionCharts, Column2D, FusionTheme);